import Twemoji from "react-twemoji";
import React, { type ReactNode, useMemo } from "react";
import "./styles.scss";

interface Props {
  children: ReactNode | ReactNode[];
  isText?: boolean;
  isSmall?: boolean;
  isMediumText?: boolean;
  isBigText?: boolean;
  isVeryBigText?: boolean;
  className?: string;
}

export default function TwemojiWrapper(props: Props) {
  const className = useMemo(() => {
    const classes = [
      props.isVeryBigText ? "twemoji-text-very-big" : "",
      props.isBigText ? "twemoji-text-big" : "",
      props.isText ? "twemoji-text" : "",
      props.isMediumText ? "twemoji-medium" : "",
      props.isSmall ? "twemoji-small" : "",
      props.className ?? ""
    ].filter((c) => !!c);
    return classes.length > 0 ? classes.join(" ") : "emoji";
  }, [props]);

  return (
    <Twemoji
      options={{
        base: "https://d19y19rxbpc628.cloudfront.net/jetpack/twemoji/14.0.1/",
        folder: "svg",
        ext: ".svg",
        className: className || undefined
      }}
    >
      {props.children}
    </Twemoji>
  );
}
